import { api } from "./api";

let cached = null;

export async function getAuthConfig() {
  if (cached) return cached;
  try {
    const { data } = await api.get("/auth/config");
    cached = data;
  } catch {
    cached = { provider: "emergent" };
  }
  return cached;
}
